/**
 * URL の予約アクセストークン (`/reservations/{reservationToken}/...`) を RPC 呼び出し側
 * (interceptor) へ受け渡すための一時保持モジュール (caseToken.ts と同方式)。
 *
 * 予約完了画面は決済成功後の success_url (§7.1) で遷移するため案件アクセストークンを持たず、
 * URL の予約アクセストークンだけが GetReservation の認可の根拠になる。ルーティング側
 * (ReservationTokenLayout) が URL パラメータに合わせて `setReservationToken` を呼び、
 * reservationTokenInterceptor が呼び出しのたびに `getReservationToken` を評価してヘッダへ反映する。
 */
let currentReservationToken: string | undefined;

export function setReservationToken(token: string | undefined): void {
  currentReservationToken = token;
}

export function getReservationToken(): string | undefined {
  return currentReservationToken;
}
